export const VOICE_LIST = [
    {
        "header": "af-ZA",
        "voice": "AdriNeural"
    },
    {
        "header": "am-ET",
        "voice": "MekdesNeural"
    },
    {
        "header": "ar-AE",
        "voice": "FatimaNeural"
    },
    {
        "header": "ar-BH",
        "voice": "LailaNeural"
    },
    {
        "header": "ar-DZ",
        "voice": "AminaNeural"
    },
    {
        "header": "ar-EG",
        "voice": "SalmaNeural"
    },
    {
        "header": "ar-IQ",
        "voice": "RanaNeural"
    },
    {
        "header": "ar-JO",
        "voice": "SanaNeural"
    },
    {
        "header": "ar-KW",
        "voice": "NouraNeural"
    },
    {
        "header": "ar-LB",
        "voice": "LaylaNeural"
    },
    {
        "header": "ar-LY",
        "voice": "ImanNeural"
    },
    {
        "header": "ar-MA",
        "voice": "MounaNeural"
    },
    {
        "header": "ar-OM",
        "voice": "AyshaNeural"
    },
    {
        "header": "ar-QA",
        "voice": "AmalNeural"
    },
    {
        "header": "ar-SA",
        "voice": "ZariyahNeural"
    },
    {
        "header": "ar-SY",
        "voice": "AmanyNeural"
    },
    {
        "header": "ar-TN",
        "voice": "ReemNeural"
    },
    {
        "header": "ar-YE",
        "voice": "MaryamNeural"
    },
    {
        "header": "as-IN",
        "voice": "YashicaNeural"
    },
    {
        "header": "az-AZ",
        "voice": "BanuNeural"
    },
    {
        "header": "bg-BG",
        "voice": "KalinaNeural"
    },
    {
        "header": "bn-BD",
        "voice": "NabanitaNeural"
    },
    {
        "header": "bn-IN",
        "voice": "TanishaaNeural"
    },
    {
        "header": "bs-BA",
        "voice": "VesnaNeural"
    },
    {
        "header": "ca-ES",
        "voice": "JoanaNeural"
    },
    {
        "header": "cs-CZ",
        "voice": "VlastaNeural"
    },
    {
        "header": "cy-GB",
        "voice": "NiaNeural"
    },
    {
        "header": "da-DK",
        "voice": "ChristelNeural"
    },
    {
        "header": "de-AT",
        "voice": "IngridNeural"
    },
    {
        "header": "de-CH",
        "voice": "ArianeNeural"
    },
    {
        "header": "de-DE",
        "voice": "KatjaNeural"
    },
    {
        "header": "el-GR",
        "voice": "AthinaNeural"
    },
    {
        "header": "en-AU",
        "voice": "NatashaNeural"
    },
    {
        "header": "en-CA",
        "voice": "ClaraNeural"
    },
    {
        "header": "en-GB",
        "voice": "SoniaNeural"
    },
    {
        "header": "en-HK",
        "voice": "YanNeural"
    },
    {
        "header": "en-IE",
        "voice": "EmilyNeural"
    },
    {
        "header": "en-IN",
        "voice": "AaravNeural"
    },
    {
        "header": "en-KE",
        "voice": "AsiliaNeural"
    },
    {
        "header": "en-NG",
        "voice": "EzinneNeural"
    },
    {
        "header": "en-NZ",
        "voice": "MollyNeural"
    },
    {
        "header": "en-PH",
        "voice": "RosaNeural"
    },
    {
        "header": "en-SG",
        "voice": "LunaNeural"
    },
    {
        "header": "en-TZ",
        "voice": "ImaniNeural"
    },
    {
        "header": "en-US",
        "voice": "AvaNeural"
    },
    {
        "header": "en-ZA",
        "voice": "LeahNeural"
    },
    {
        "header": "es-AR",
        "voice": "ElenaNeural"
    },
    {
        "header": "es-CL",
        "voice": "CatalinaNeural"
    },
    {
        "header": "es-CO",
        "voice": "SofiaNeural"
    },
    {
        "header": "es-ES",
        "voice": "ElviraNeural"
    },
    {
        "header": "es-MX",
        "voice": "DaliaNeural"
    },
    {
        "header": "es-US",
        "voice": "PaolaNeural"
    },
    {
        "header": "et-EE",
        "voice": "AnuNeural"
    },
    {
        "header": "eu-ES",
        "voice": "AinhoaNeural"
    },
    {
        "header": "fa-IR",
        "voice": "DilaraNeural"
    },
    {
        "header": "fi-FI",
        "voice": "SelmaNeural"
    },
    {
        "header": "fr-CA",
        "voice": "SylvieNeural"
    },
    {
        "header": "fr-FR",
        "voice": "DeniseNeural"
    },
    {
        "header": "ga-IE",
        "voice": "OrlaNeural"
    },
    {
        "header": "gl-ES",
        "voice": "SabelaNeural"
    },
    {
        "header": "gu-IN",
        "voice": "KavyaNeural"
    },
    {
        "header": "he-IL",
        "voice": "HilaNeural"
    },
    {
        "header": "hi-IN",
        "voice": "NeerjaNeural"
    },
    {
        "header": "hr-HR",
        "voice": "GabrijelaNeural"
    },
    {
        "header": "hu-HU",
        "voice": "NoemiNeural"
    },
    {
        "header": "hy-AM",
        "voice": "AnahitNeural"
    },
    {
        "header": "id-ID",
        "voice": "GadisNeural"
    },
    {
        "header": "it-IT",
        "voice": "ElsaNeural"
    },
    {
        "header": "ja-JP",
        "voice": "NanamiNeural"
    },
    {
        "header": "ka-GE",
        "voice": "EkaNeural"
    },
    {
        "header": "kk-KZ",
        "voice": "AigulNeural"
    },
    {
        "header": "km-KH",
        "voice": "SreymomNeural"
    },
    {
        "header": "kn-IN",
        "voice": "SapnaNeural"
    },
    {
        "header": "ko-KR",
        "voice": "SunHiNeural"
    },
    {
        "header": "lt-LT",
        "voice": "OnaNeural"
    },
    {
        "header": "lv-LV",
        "voice": "EveritaNeural"
    },
    {
        "header": "mk-MK",
        "voice": "MarijaNeural"
    },
    {
        "header": "ml-IN",
        "voice": "SobhanaNeural"
    },
    {
        "header": "mn-MN",
        "voice": "YesuiNeural"
    },
    {
        "header": "mr-IN",
        "voice": "AarohiNeural"
    },
    {
        "header": "ms-MY",
        "voice": "YasminNeural"
    },
    {
        "header": "mt-MT",
        "voice": "GraceNeural"
    },
    {
        "header": "my-MM",
        "voice": "NilarNeural"
    },
    {
        "header": "ne-NP",
        "voice": "HemkalaNeural"
    },
    {
        "header": "nl-BE",
        "voice": "DenaNeural"
    },
    {
        "header": "nl-NL",
        "voice": "MaartenNeural"
    },
    {
        "header": "pl-PL",
        "voice": "AgnieszkaNeural"
    },
    {
        "header": "pt-BR",
        "voice": "FranciscaNeural"
    },
    {
        "header": "pt-PT",
        "voice": "RaquelNeural"
    },
    {
        "header": "ro-RO",
        "voice": "AlinaNeural"
    },
    {
        "header": "ru-RU",
        "voice": "DmitryNeural"
    },
    {
        "header": "si-LK",
        "voice": "ThiliniNeural"
    },
    {
        "header": "sk-SK",
        "voice": "ViktoriaNeural"
    },
    {
        "header": "sl-SI",
        "voice": "NinaNeural"
    },
    {
        "header": "so-SO",
        "voice": "UbaxNeural"
    },
    {
        "header": "sq-AL",
        "voice": "AnilaNeural"
    },
    {
        "header": "sr-RS",
        "voice": "SophieNeural"
    },
    {
        "header": "su-ID",
        "voice": "TutiNeural"
    },
    {
        "header": "sv-SE",
        "voice": "SofieNeural"
    },
    {
        "header": "sw-TZ",
        "voice": "AmaniNeural"
    },
    {
        "header": "ta-IN",
        "voice": "PallaviNeural"
    },
    {
        "header": "ta-LK",
        "voice": "SaranyaNeural"
    },
    {
        "header": "te-IN",
        "voice": "ShrutiNeural"
    },
    {
        "header": "th-TH",
        "voice": "PremwadeeNeural"
    },
    {
        "header": "tr-TR",
        "voice": "EmelNeural"
    },
    {
        "header": "uk-UA",
        "voice": "PolinaNeural"
    },
    {
        "header": "ur-PK",
        "voice": "UzmaNeural"
    },
    {
        "header": "vi-VN",
        "voice": "HoaiMyNeural"
    },
  { "header": "zh-CN-henan",
     "voice": "YundengNeural" 
    },
  { "header": "zh-CN-shaanxi",
     "voice": "XiaoniNeural" 
    },
  { "header": "zh-HK",
     "voice":"HiuMaanNeural"
     },
  { "header": "zh-TW", 
    "voice": "HsiaoChenNeural" 
  },
  { "header": "zu-ZA",
     "voice": "ThandoNeural"
     }
  ]